import 'css-chunksrc/client/pages/zonePage/wbsPage/exportButton/loader/styles.scss';export default {
  "loader": "_loader_mdg26_1",
  "spin": "_spin_mdg26_1"
};